<template>
  <div class="d-flex justify-content-center spinner-div">
    <div
      class="spinner-grow center spinner "
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
};
</script>

<style scoped>
.spinner-div {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 10;
    overflow: hidden;
    background: rgba(0,0,0,0.7);
}

.spinner{
    display: block;
    position: absolute;
    top: 40%;
    width: 8rem;
    height: 8rem;
    color: #f9f9f9;
    border-width: 4px;
    animation: 1.5s ease infinite spinner-grow;
    background-image: url("../assets/img/icon-rectangular.png");
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: 80%; /* Resize the background image to cover the entire container */
}
</style>
